import React from 'react'
import './Product.css'
import RatingStars from '../RatingStars'
import Price from '../Price'
import Button from '../Button'

type ProductProps = {
  data: any
  to: string
  textPriceClub?: string
  textPrice?: string
  className?: string
  textAddToCart?: string
  showClubPrice?: boolean
  onNavigate?: (e: any) => void
  onAddToCart?: null | (() => void)
  buttonStyle?: React.CSSProperties
}

function Product({
  data,
  to,
  textPriceClub = 'PRICE',
  textPrice = 'PRICE',
  textAddToCart = 'ADD TO CART',
  showClubPrice = false,
  className = '',
  buttonStyle,
  onNavigate,
  onAddToCart = null
}: ProductProps) {
  return (
    <div className={'cocunat-Product ' + className}>
      <a href={to} onClick={onNavigate}>
        <figure>
          <img
            src={`https://resizing.cocunat.com/r/?quality=90&fit=contain&width=285&height=355&image=https://global.cocunat.com/${
              data.pretty_image
                ? 'photos/' + data.pretty_image
                : 'photos/' + data.image
            }`}
            alt={data.translation.name}
            loading='lazy'
            width='285'
            height='355'
          />
        </figure>
        <p style={{ fontSize: 12 }}>
          <RatingStars rating={data.rating} size={12} />
          <span style={{ marginLeft: 5 }}>
            {data.rating} ({data.comments_summary.num})
          </span>
        </p>
        <p
          className={
            data.prices && data.prices.show_gourmet && showClubPrice
              ? 'cocunat-Product_title cocunat-Product_show-club'
              : 'cocunat-Product_title'
          }
        >
          <strong>{data.translation.name}</strong>
          <span>{data.translation.subtitle}</span>
          {data.prices && data.prices.show_gourmet && showClubPrice && (
            <p
              style={{
                fontSize: '14px',
                margin: '10px 0px',
                height: 15,
                textAlign: 'left',
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <strong>{textPriceClub}:</strong>
              <strong>
                <Price
                  style={{ float: 'right' }}
                  prices={data.prices}
                  showGourmetDiscount={
                    data.prices && data.prices.show_gourmet && showClubPrice
                  }
                />
              </strong>
            </p>
          )}
          <p
            className='cocunat-Product_price-original'
            style={{
              fontSize: '14px',
              margin: '10px 0px',
              height: 15,
              textAlign: 'left',
              display: 'flex',
              justifyContent: 'space-between',
              color: '#767676'
            }}
          >
            {textPrice}:{' '}
            <Price prices={data.prices} showGourmetDiscount={false} />
          </p>
        </p>
      </a>
      {onAddToCart && (
        <Button style={buttonStyle} onClick={onAddToCart}>
          {textAddToCart}
        </Button>
      )}
    </div>
  )
}

export default Product
